import React, { useEffect, useState } from 'react';

import Api, { exceptionNotificationAPI } from '../../services/api';
import FormCrud from '../../components/FormCrud';
import { options } from 'toastr';

const GroupForm = () => {
    const [cultureOptions, setCultureOptions] = useState([]);
    const [companiesOptions, setCompaniesOptions] = useState([]);
    const booleanOptions = [
        { value: true, text: "Yes" },
        { value: false, text: "No" }
    ];
     const [userObject, setUserObject] = useState(
            JSON.parse(localStorage.getItem('@Thrive:user')),
          );

    const loadData = async () => {
        await Api.get('Culture/GetAll').then((result) => {
            if (result && result.data) {
                const options = result.data.response.map(item => ({ value: item.cultureID, text: item.cultureDisplayName }));
                setCultureOptions(options)
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
        await Api.get(`Company/getAllByCulture?cultureID=${userObject.selectedCultureID}`).then((result) => {
            if (result && result.data) {
                const options = result.data.response.map(item => ({ value: item.companyID, text: `${item.name}` }));

                setCompaniesOptions(options);
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
            
    }

    useEffect(() => {
        loadData();
    }, []);

    const fields = [
        {
            label: "Name",
            name: "name",
            type: "input"
        },
        {
            label: "Order",
            name: "order",
            type: "number"
        },
        {
            label: "Companies",
            name: "groupCompany",
            type: "select",
            required: false,
            options: companiesOptions,
            multiple: true
        },
        {
            label: "Culture",
            name: "cultureID",
            type: "select",
            options: cultureOptions,
        },
        {
            label: "Is PowerBI Group?",
            name: "isPowerBI",
            type: "select",
            options: booleanOptions
        },
        {
            label: "Is ReadOnly View?",
            name: "isReadOnlyView",
            type: "select",
            options: booleanOptions
        },
        {
            label: "Is Active",
            name: "isActive",
            type: "select",
            options: booleanOptions
        },
        {
            label: "Enable Simulation",
            name: "enableSimulation",
            type: "select",
            options: booleanOptions
        }
    ]

    return (
        cultureOptions.length > 0 ? <FormCrud formName={"group"} title={"Group"} fields={fields} /> : <></>    
    );
}

export default GroupForm;
